module.exports = __webpack_public_path__ + "static/media/isotipo-normal.739bb4f9.png";